import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from "../store/actions";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import TopBar from '../components/Navigation/TopBar';
import MenuBar from '../components/Navigation/MenuBar';
import Dashboard from "./DashboardView";
import MapView from './MapView';
import Reports from './ReportsView';
import Cars from './CarsView';
import Drivers from "./DriversView";
import Settings from './SettingsView';
import RentsView from "./RentsView";
import GroupsView from './GroupsView';
import t from "../languages/pl";
import ManageUsersView from './ManageUsersView';
import RodoDialog from '../components/Utilities/RodoDialog';
import ForcePasswordChangeDialog from '../components/Utilities/ForcePasswordChangeDialog';
import InformationDialog from '../components/Common/InformationDialog';


const possibleLocations = {
    root: "/",
    map: "/map",
    reports: "/reports",
    cars: "/cars",
    drivers: "/drivers",
    groups: "/groups",
    manageUsers: "/manageusers",
    rents: "/rents",
    settings: "/settings"
};

function Routes(props) {
    const { rodoNotAccepted, isGpsEnabled, isForcedPasswordChange, isForcedPasswordDialogOpen, repeatedPassword, forcePasswordChangeMessage, role } = props;

    useEffect(() => {
        props.getFilters();
        props.getCarsDetails();
        props.getDrivers();
        props.getRentClients();
        props.getContactData();
    }, []);

    const handleRodoAccept = () => {
        props.rodoAccept();
    };

    const handleForcePassword = (password) => {
        props.forcePassword(password);
    };

    return (
        <BrowserRouter>
            <MenuBar>
                <Switch>
                    <Route
                        path={possibleLocations.root}
                        exact
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.dashboard} />
                                <Dashboard />
                            </React.Fragment>
                        )}
                    />
                    {isGpsEnabled && <Route
                        path={possibleLocations.map}
                        render={() => {
                            props.closeDrawer();
                            return (
                                <React.Fragment>
                                    <TopBar title={t.mapAppbarTitle}/>
                                    <MapView/>
                                </React.Fragment>
                            );
                        }}
                    />}
                    <Route
                        path={possibleLocations.reports}
                        exact
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.reports} />
                                <Reports />
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path={possibleLocations.cars}
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.cars} />
                                <Cars />
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path={possibleLocations.drivers}
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.drivers} />
                                <Drivers />
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path={possibleLocations.groups}
                        exact
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.groups} />
                                <GroupsView />
                            </React.Fragment>
                        )}
                    />
                    { role === "admin"  && <Route
                        path={possibleLocations.manageUsers}
                        exact
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.manageUsers} />
                                <ManageUsersView />
                            </React.Fragment>
                        )}
                    /> }
                    {(role === "admin" || role === "podadmin" || role === 'tymczasowy') && <Route
                        path={possibleLocations.rents}
                        exact
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.rents} />
                                <RentsView />
                            </React.Fragment>
                        )}
                    />}
                    <Route
                        path={possibleLocations.settings}
                        exact
                        render={() => (
                            <React.Fragment>
                                <TopBar title={t.settings} />
                                <Settings />
                            </React.Fragment>
                        )}
                    />
                </Switch>
            </MenuBar>
            <RodoDialog
                open={rodoNotAccepted}
                onClose={handleRodoAccept}
            />
            <ForcePasswordChangeDialog
                open={isForcedPasswordChange}
                repeatedPasswoord={repeatedPassword}
                forcePasswordChangeMessage={forcePasswordChangeMessage}
                onClose={handleForcePassword}
            />
            <InformationDialog
                open={isForcedPasswordDialogOpen}
                size="sm"
                onClose={() => props.logout()}
                title={t.successfullyChangedForcedPasswordTitle}
                content={t.successfullyChangedForcedPasswordContent}
            />
        </BrowserRouter>
    );
}


const mapStateToProps = state => {
    return {
        rodoNotAccepted: state.requestReducer.rodoNotAccepted,
        isGpsEnabled: state.authReducer.isGpsEnabled,
        isForcedPasswordChange: state.authReducer.forcePasswordChange,
        repeatedPassword: state.authReducer.repeatedPassword,
        isForcedPasswordDialogOpen: state.requestReducer.isForcedPasswordDialogOpen,
        forcePasswordChangeMessage: state.authReducer.forcePasswordChangeMessage,
        role: state.authReducer.role,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Routes);

Routes.propTypes = {
    rodoNotAccepted: PropTypes.bool,
    welcomeDialog: PropTypes.bool,
    //redux
    closeDrawer: PropTypes.func,
    getFilters: PropTypes.func,
    getCarsDetails: PropTypes.func,
    getContactData: PropTypes.func,
    getDrivers: PropTypes.func,
    getRentClients: PropTypes.func,
    changeWelcomeDialogState: PropTypes.func,
    rodoAccept: PropTypes.func,
    isGpsEnabled: PropTypes.bool,
    isForcedPasswordChange: PropTypes.bool,
    forcePassword: PropTypes.func,
    repeatedPassword: PropTypes.bool,
    isForcedPasswordDialogOpen: PropTypes.bool,
    forcePasswordChangeMessage: PropTypes.string,
    logout: PropTypes.func,
    role: PropTypes.string,
};
